module.exports = __webpack_public_path__ + "static/media/Aleo-Bold.82b24ca5.otf";


/*****************
 ** WEBPACK FOOTER
 ** ./public/fonts/Aleo-Bold.otf
 ** module id = 1875
 ** module chunks = 50
 **/